import styled from "styled-components";

export const GenrealInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding: 20px 10px;
  margin-bottom: 15px;
`;

export const Title = styled.h2`
  color: ${(props) => (props?.color ? props.color : "#00aeea")};
  font-size: 18px;
  font-family: lato;
  text-transform: initial;
  line-height: 1;
  margin-top: 0px;
  font-weight: bold !important;
  justify-self: auto;
  margin-bottom: ${(props) => (props?.bottom ? props.bottom : "10px")};
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  font-size: 14px;
  color: #ffffff;
  line-height: 1rem;
  border-right: ${(props) => props.borderRight ?? "0px solid #767676"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
  border-bottom-right-radius: ${(props) => props.borderRadius ?? "0px"};
  border-bottom-left-radius: ${(props) => props.borderRadius ?? "0px"};
  padding: ${(props) => props?.padding ?? "0px"};
`;

export const ButtonWrapper = styled.div`
  text-align: right;
  position: relative;
`;

export const CalculationOuter = styled.div`
  border: 2px solid #008395;
  border-radius: 5px;
`;
export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  text-align: center;
`;
